module.exports = __webpack_public_path__ + "static/media/EBGaramond-SemiBold.98ae541d.woff2";